import { render, staticRenderFns } from "./Email.vue?vue&type=template&id=523d51d9&lang=pug"
import script from "./Email.vue?vue&type=script&lang=ts"
export * from "./Email.vue?vue&type=script&lang=ts"
import style0 from "./Email.vue?vue&type=style&index=0&id=523d51d9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports